import { AutoAwesome as AutoAwesomeIcon } from '@mui/icons-material'
import { Alert, AlertTitle, Button } from '@mui/material'
import React from 'react'
import { useHistory } from 'react-router-dom'

const NonSMEPage = () => {
  const history = useHistory()
  return (
    <div>
      <Alert severity="info">
        <AlertTitle>Filters have now been removed!</AlertTitle>
        <p>
          We no longer support filters on this page. Please use the 'Next Reference' menu
          option on the left menu bar to navigate to the next reference, or alternatively
          click below:
        </p>
        <Button
          startIcon={<AutoAwesomeIcon />}
          onClick={() => history.push('/next-applicant')}
        >
          Next Reference
        </Button>
      </Alert>
    </div>
  )
}

export default NonSMEPage
